/* Bactera product pages (Gut, Oral, Vaginal, Gut Kids): behaviours on top of
   vc.js. Loaded by snippets/vc-pd-head next to vc.js.
   1. background and card videos load when they come on screen
   2. the sticky buy bar
   3. the age-stage switch of the kids page, with its own analysis explorer
   4. the launch sign-up form's address check
   5. the buy buttons, when they lead straight to the checkout
   6. the welcome gift card and its tab */
(function () {
  'use strict';

  /* vc-pd-head renders once per VC section, so the tag appears many times;
     the browser runs the file once per tag, and this must happen once. */
  if (window.__vcPdLoaded) return;
  window.__vcPdLoaded = true;

  /* Background and card videos carry their files in data-src (and the
     data-src-hls/-480/-720 alternatives) and load one only when they come
     on screen; they play while visible and pause when scrolled away. With
     reduced motion the still picture simply stays. */
  function bindVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('.vc video[data-vc-bgvideo]:not([data-vc-bound])'));
    if (!vids.length) return;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    vids.forEach(function (v) { v.setAttribute('data-vc-bound', '1'); });
    if (reduce) return;
    function start(v) {
      if (!v.getAttribute('src') && v.getAttribute('data-src')) {
        v.muted = true; v.loop = true; v.setAttribute('playsinline', '');
        v.addEventListener('loadeddata', function () { v.classList.add('ready'); }, { once: true });
        /* The file to play. Liquid offers only the HLS stream and the largest
           MP4 of a video; vc-bgmedia adds the 480p and 720p files it knows.
           Safari, and every browser on iOS, plays the stream natively and
           picks the bitrate itself; other narrow screens take a small file
           when there is one; everything else takes the large MP4. */
        var src = v.getAttribute('data-src'), w = window.innerWidth;
        var hls = v.getAttribute('data-src-hls'), s480 = v.getAttribute('data-src-480'), s720 = v.getAttribute('data-src-720');
        if (hls && v.canPlayType('application/vnd.apple.mpegurl')) src = hls;
        else if (w < 640 && (s480 || s720)) src = s480 || s720;
        else if (w < 1100 && s720) src = s720;
        v.src = src;
      }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) { if (x.isIntersecting) start(x.target); else x.target.pause(); });
    }, { threshold: 0.05 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* The sticky buy bar slides in once the buy row (or the launch sign-up)
     has scrolled above the viewport, and steps aside near the page end and
     while one of the theme's drawers (cart, menu, search) is open. On
     desktop its fold-away button folds the card into a small pill with the
     price, which opens it again; the fold is remembered for the visit. The
     mobile layout has neither, so there the bar always shows in full and
     the stylesheet lifts it above the theme's menu bar whenever that is
     up. Its quantity and the buy form's quantity stay in step, because the
     bar's button submits the buy form. While hidden it is inert, so
     keyboard users skip it. */
  var STICKY_KEY = 'vcStickyMin';
  /* the bare scope wrapper at the end of the page that fixed elements move
     into (the sticky bar, the back-to-top button); one per page */
  function floatWrap(root) {
    var wrap = document.querySelector('.vc-float');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = root.className + ' vc-float';
      document.body.appendChild(wrap);
    }
    return wrap;
  }
  function stickyMin() { try { return sessionStorage.getItem(STICKY_KEY) === '1'; } catch (e) { return false; } }
  /* The theme marks an open drawer or modal on its overlay (painted, or
     aria-expanded), on the element itself (open), or by locking the page
     scroll; any of these counts. */
  function themeOverlays() {
    return Array.prototype.filter.call(document.querySelectorAll('overlay-element, .drawer, .x-modal'), function (el) { return !el.closest('.vc'); });
  }
  function overlayOpen(els) {
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.isConnected) continue;
      if (el.hasAttribute('open') || el.getAttribute('aria-expanded') === 'true') return true;
      if (el.tagName === 'OVERLAY-ELEMENT') {
        var cs = getComputedStyle(el);
        if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05) return true;
      }
    }
    return getComputedStyle(document.documentElement).overflowY === 'hidden' || getComputedStyle(document.body).overflowY === 'hidden';
  }
  function bindSticky() {
    var bar = document.querySelector('.vc [data-vc-sticky]');
    if (!bar || bar.getAttribute('data-vc-bound')) return;
    bar.setAttribute('data-vc-bound', '1');
    var root = bar.closest('.vc') || document;
    var anchor = root.querySelector('.pbuy, .notify, .pinfo');
    var buyQty = root.querySelector('#vc-pdp-buy .qty-num');
    var barQty = bar.querySelector('.qty-num');
    /* every section is its own stacking context, so a fixed bar left inside
       the buy area would be painted over by the sections that follow; it
       moves to the end of the page inside a bare scope wrapper instead */
    if (root !== document && !(window.Shopify && Shopify.designMode)) {
      floatWrap(root).appendChild(bar);
    }
    if (buyQty && barQty) {
      var sync = function (from, to) { return function () { if (to.value !== from.value) to.value = from.value; }; };
      ['input', 'change'].forEach(function (ev) {
        barQty.addEventListener(ev, sync(barQty, buyQty));
        buyQty.addEventListener(ev, sync(buyQty, barQty));
      });
    }
    /* the theme's own breakpoint for its mobile layout and menu bar */
    var mobile = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    /* folding keeps the bar in place: the card gives way to the pill */
    var card = bar.querySelector('.sbx-card');
    var x = bar.querySelector('[data-vc-sticky-close]');
    var opener = bar.querySelector('[data-vc-sticky-open]');
    function fold(on, moveFocus) {
      bar.classList.toggle('min', on);
      if (x) x.setAttribute('aria-expanded', on ? 'false' : 'true');
      if (opener) opener.setAttribute('aria-expanded', on ? 'false' : 'true');
      try {
        if (on) sessionStorage.setItem(STICKY_KEY, '1');
        else sessionStorage.removeItem(STICKY_KEY);
      } catch (e) {}
      if (!moveFocus) return;
      var to = on ? opener : (card && (card.querySelector('.sbx-btn') || card.querySelector('button, a')));
      if (to && to.offsetParent) to.focus();
    }
    if (x) x.addEventListener('click', function () { fold(true, true); });
    if (opener) opener.addEventListener('click', function () { fold(false, true); });
    fold(stickyMin(), false);
    function show(on) {
      bar.classList.toggle('on', on);
      if (on) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    }
    if (!anchor) { show(false); return; }
    var overlays = themeOverlays();
    function check() {
      var r = anchor.getBoundingClientRect();
      var atEnd = (window.innerHeight + window.scrollY) > (document.body.scrollHeight - 220);
      show(r.bottom < 0 && !atEnd && !overlayOpen(overlays));
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if (mobile) {
      if (mobile.addEventListener) mobile.addEventListener('change', check);
      else if (mobile.addListener) mobile.addListener(check);
    }
    /* drawers open and close without a scroll: watch them, and the page's
       scroll lock, and look again once their transition has run */
    if (window.MutationObserver) {
      var queued = false, later = 0;
      var mo = new MutationObserver(function () {
        if (!queued) {
          queued = true;
          requestAnimationFrame(function () { queued = false; check(); });
        }
        clearTimeout(later);
        later = setTimeout(check, 450);
      });
      var attrs = { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-expanded'] };
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
      mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
      overlays.forEach(function (el) { mo.observe(el, attrs); });
    }
    check();
  }

  /* The back-to-top button: a small pill at the bottom left that appears
     once the page has scrolled more than a screen, sits above the sticky
     bar or the theme's menu bar whenever one of them is up, steps aside
     with the bar while a drawer is open, and scrolls back to the top. Like
     the bar it moves to the end of the page. */
  function bindToTop() {
    var btn = document.querySelector('.vc [data-vc-totop]');
    if (!btn || btn.getAttribute('data-vc-bound')) return;
    btn.setAttribute('data-vc-bound', '1');
    var root = btn.closest('.vc');
    if (root && !(window.Shopify && Shopify.designMode)) floatWrap(root).appendChild(btn);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var overlays = themeOverlays();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, left: 0, behavior: reduce ? 'auto' : 'smooth' });
      btn.blur();
    });
    function place() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var h = window.innerHeight;
      btn.classList.toggle('on', y > h * 1.2 && !overlayOpen(overlays));
      var bottom = 16;
      var bar = document.querySelector('[data-vc-sticky].on');
      var dock = document.querySelector('.mobile-dock-section');
      if (bar) {
        var r = bar.getBoundingClientRect();
        if (r.height && r.top < h) bottom = Math.max(bottom, Math.round(h - r.top) + 12);
      } else if (dock && getComputedStyle(dock).display !== 'none') {
        var d = dock.getBoundingClientRect();
        if (d.height && d.top < h) bottom = Math.max(bottom, Math.round(h - d.top) + 12);
      }
      btn.style.bottom = bottom + 'px';
    }
    var ticking = false;
    function queue() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { place(); ticking = false; });
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    /* the bar shows a moment after the scroll that triggered it */
    window.addEventListener('scroll', function () { setTimeout(queue, 120); }, { passive: true });
    place();
  }

  /* Age stages (kids page). Every element with data-stage="<key>" belongs to
     one stage; the live stage gets .is-live and the stylesheet shows only
     those. The stage buttons (data-stagebtn) and the age picker in the buy
     area (select[data-agepick], options carry data-stagekey) drive the same
     switch. Each control is bound once, so a section the theme editor
     re-renders gets its listeners again without doubling the others. */
  function setStage(v, fromSelect) {
    if (!v) return;
    document.querySelectorAll('.vc [data-stage]').forEach(function (el) {
      el.classList.toggle('is-live', el.getAttribute('data-stage') === v);
    });
    document.querySelectorAll('.vc [data-stagebtn]').forEach(function (b) {
      var on = b.getAttribute('data-stagebtn') === v;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    /* texts that name the stage (the report card title) or the example
       child's age (the stage bar note) carry one attribute per stage */
    document.querySelectorAll('.vc [data-stagelabel]').forEach(function (x) {
      var t = x.getAttribute('data-label-' + v); if (t !== null) x.textContent = t;
    });
    document.querySelectorAll('.vc [data-stageage]').forEach(function (x) {
      var t = x.getAttribute('data-age-' + v); if (t !== null) x.textContent = t;
    });
    if (!fromSelect) {
      document.querySelectorAll('.vc select[data-agepick]').forEach(function (sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].getAttribute('data-stagekey') === v) { sel.selectedIndex = i; break; }
        }
      });
    }
  }
  function bindStages() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('.vc [data-stagebtn]:not([data-vc-bound])'));
    var picks = Array.prototype.slice.call(document.querySelectorAll('.vc select[data-agepick]:not([data-vc-bound])'));
    if (!btns.length && !picks.length) return;
    btns.forEach(function (b) {
      b.setAttribute('data-vc-bound', '1');
      b.addEventListener('click', function () { setStage(b.getAttribute('data-stagebtn')); });
    });
    picks.forEach(function (sel) {
      sel.setAttribute('data-vc-bound', '1');
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        setStage(o && o.getAttribute('data-stagekey'), true);
      });
    });
    var on = document.querySelector('.vc [data-stagebtn].is-on') || document.querySelector('.vc [data-stagebtn]');
    var first = on ? on.getAttribute('data-stagebtn') : null;
    if (!first) {
      var o = document.querySelector('.vc select[data-agepick] option[data-stagekey]:not([data-stagekey=""])');
      first = o && o.getAttribute('data-stagekey');
    }
    setStage(first, true);
  }

  /* The kids analysis explorer holds one tab set per age stage. vc.js skips
     it (the root is printed with data-vc-bound), so each set is bound here
     on its own: a tab shows its pane within the set, arrow keys move along
     the tabs, and on phones the pane headers open and close their pane,
     the first pane of every set starting open. */
  function bindStageExplorer() {
    document.querySelectorAll('.vc [data-vc-stagexp] .xp-set:not([data-vc-setbound])').forEach(function (set) {
      set.setAttribute('data-vc-setbound', '1');
      var tabs = Array.prototype.slice.call(set.querySelectorAll('.xp-nav > .xp-tab'));
      var panes = Array.prototype.slice.call(set.querySelectorAll('.xp-panes > .xp-pane'));
      function show(i) {
        tabs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panes.forEach(function (p, j) { p.classList.toggle('is-on', j === i); });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n === null) return;
          e.preventDefault(); tabs[n].focus(); show(n);
        });
      });
      panes.forEach(function (p, i) {
        var h = p.querySelector('.xp-ph');
        if (!h) return;
        if (i === 0) p.classList.add('is-open');
        h.addEventListener('click', function () {
          var open = !p.classList.contains('is-open');
          p.classList.toggle('is-open', open);
          h.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* The launch sign-up: an address that cannot be one shows the form's own
     error state at once instead of a round trip to the server; typing again
     clears it. A valid address is always sent. */
  function bindNotify() {
    document.querySelectorAll('.vc .notify form:not([data-vc-bound])').forEach(function (f) {
      f.setAttribute('data-vc-bound', '1');
      var box = f.closest('.notify');
      var input = f.querySelector('input[type="email"]');
      if (!box || !input) return;
      f.addEventListener('submit', function (e) {
        var v = (input.value || '').trim();
        if (v.length > 3 && input.checkValidity()) return;
        e.preventDefault();
        box.classList.add('is-err');
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      });
      input.addEventListener('input', function () {
        box.classList.remove('is-err');
        input.removeAttribute('aria-invalid');
      });
    });
  }

  /* The buy buttons. With the section set to lead to the checkout, a submit
     of the buy form (the main button, the price box button and the sticky
     bar all submit it) sets the cart to the chosen quantity of the chosen
     variant and opens the checkout. Setting, rather than adding, keeps the
     quantity at what the page shows when a visitor comes back from the
     checkout and buys again. The checkout is entered the way the cart page
     enters it: a post to the cart with the checkout field, which keeps the
     language. Buy links elsewhere on the page ([data-vc-buy], the section
     Who it is for) run the same purchase; without a buy form they stay
     plain links to the buy area. Should the cart request fail, the form is
     sent the ordinary way, and its return_to field still lands in the
     checkout. */
  function bindBuy() {
    var form = document.getElementById('vc-pdp-buy');
    if (!form || form.getAttribute('data-vc-buy-bound')) return;
    form.setAttribute('data-vc-buy-bound', '1');
    var toCheckout = form.getAttribute('data-vc-target') === 'checkout';
    var cartUrl = form.getAttribute('data-vc-cart') || '/cart';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    var busy = false;
    function setBusy(on) {
      busy = on;
      Array.prototype.forEach.call(document.querySelectorAll('#vc-pdp-buy [type="submit"], [form="vc-pdp-buy"], [data-vc-buy]'), function (b) {
        if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
      });
    }
    function goCheckout() {
      var f = document.createElement('form');
      f.method = 'post';
      f.action = cartUrl;
      f.style.display = 'none';
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'checkout';
      i.value = '1';
      f.appendChild(i);
      document.body.appendChild(f);
      f.submit();
    }
    function buyNow() {
      if (busy) return;
      if (form.checkValidity && !form.checkValidity()) { if (form.reportValidity) form.reportValidity(); return; }
      var idEl = form.querySelector('[name="id"]'), qtyEl = form.querySelector('[name="quantity"]');
      var id = idEl && idEl.value, qty = parseInt(qtyEl && qtyEl.value, 10);
      if (!id) { form.submit(); return; }
      if (!(qty > 0)) qty = 1;
      setBusy(true);
      var updates = {};
      updates[id] = qty;
      fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      }).then(function () {
        goCheckout();
      }).catch(function () {
        setBusy(false);
        form.submit();
      });
    }
    if (toCheckout) {
      form.addEventListener('submit', function (e) { e.preventDefault(); buyNow(); });
    }
    /* back from the checkout, Safari and others restore the page as it was
       left, buttons still busy; a shown page is never busy */
    window.addEventListener('pageshow', function () { setBusy(false); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-vc-buy]'), function (a) {
      if (a.getAttribute('data-vc-bound')) return;
      a.setAttribute('data-vc-bound', '1');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (toCheckout) buyNow();
        else if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    });
  }

  /* The welcome gift. The slim tab at the right edge shows from the start
     and opens the card. The card also opens by itself once the visitor has
     been on the page for the set time (unless a drawer of the theme is open
     just then), as long as it has not been open in this visit. It folds
     back into the tab, and a later page of the visit keeps the tab and does
     not pop up again. A sign-up keeps the gift away for a number of
     days. Card and tab move to the end of the page, where no section can
     hold them (in the theme editor too), so the tab stays at the edge of
     the screen all the way down.
     Sending is Shopify's own newsletter sign-up, left to run as on every
     Shopify form, so its spam protection (hCaptcha) adds its token unseen;
     the script only checks the address and points return_to at Shopify's
     cart link with the chosen quantity, the code and the address, which
     opens the checkout. Should the spam protection still be loading when
     the button is pressed, the form waits for it and then goes the same way.
     Should Shopify ask for its check ("I am not a robot") and send the
     visitor back to this page, the card opens again with the address.
     On a phone a heading that only just misses one line is set a touch
     smaller, so it fits on one line instead of leaving its last words on a
     line of their own.
     Shopify refuses an address whose domain cannot receive mail, and its
     answer then comes on a page of its own. So the address is checked
     before sending: a broken address gets the error note, a misspelt big
     provider or a wrong ending (gmial.com, gmx.dee) a suggestion to tap,
     and pressing the button once more sends the address as typed. Should
     Shopify still refuse one, the page comes back with the address and a
     note in the card, which opens again.
     In the theme editor the card opens while its block is selected. */
  var GIFT_BIG = ['gmail.com', 'googlemail.com', 'gmail.de', 'gmx.de', 'gmx.net', 'gmx.com', 'gmx.at', 'gmx.ch', 'web.de', 't-online.de', 'yahoo.com', 'yahoo.de', 'hotmail.com', 'hotmail.de', 'hotmail.at', 'hotmail.ch', 'outlook.com', 'outlook.de', 'outlook.at', 'live.com', 'live.de', 'live.at', 'msn.com', 'icloud.com', 'me.com', 'mac.com', 'aol.com', 'aol.de', 'freenet.de', 'posteo.de', 'mailbox.org', 'proton.me', 'protonmail.com', 'protonmail.ch', 'pm.me', 'arcor.de', 'online.de', 'email.de', 'mail.de', 'mail.com', 'vodafone.de', 'kabelmail.de', 'bluewin.ch'];
  var GIFT_ENDS = { con: 'com', cmo: 'com', comm: 'com', coom: 'com', cpm: 'com', vom: 'com', xom: 'com', ocm: 'com', cim: 'com', dee: 'de', dde: 'de', ed: 'de', dd: 'de', dr: 'de', dw: 'de', nte: 'net', ney: 'net', nett: 'net' };
  var GIFT_DOMAIN = /^(?=.{4,253}$)([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,24}$/;
  var GIFT_LOCAL = /^[^\s@<>()\[\],;:"\\]+$/;
  /* the number of typing slips between two words (a swap of neighbours
     counts as one) */
  function giftDist(a, b) {
    var m = a.length, n = b.length, d = [], i, j;
    for (i = 0; i <= m; i++) d[i] = [i];
    for (j = 0; j <= n; j++) d[0][j] = j;
    for (i = 1; i <= m; i++) {
      for (j = 1; j <= n; j++) {
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
    return d[m][n];
  }
  /* valid: the address is well formed; fix: a corrected address to offer
     (a big provider's domain within a slip or two, a known wrong ending
     mended, a comma or a doubled dot straightened), or null */
  function giftCheck(value) {
    var email = String(value || '').trim();
    var at = email.lastIndexOf('@');
    if (at < 1 || email.indexOf('@') !== at) return { valid: false, fix: null };
    var local = email.slice(0, at), dom = email.slice(at + 1).toLowerCase();
    var localOk = GIFT_LOCAL.test(local) && local.charAt(0) !== '.' && local.charAt(local.length - 1) !== '.' && local.indexOf('..') < 0;
    var valid = localOk && GIFT_DOMAIN.test(dom);
    var fixed = dom.replace(/\s+/g, '').replace(/,/g, '.').replace(/\.{2,}/g, '.').replace(/^\.+|\.+$/g, '');
    var parts = fixed.split('.');
    var end = parts.length > 1 ? parts[parts.length - 1] : '';
    var i;
    if (GIFT_ENDS[end]) { parts[parts.length - 1] = GIFT_ENDS[end]; fixed = parts.join('.'); }
    if (parts.length === 1) {
      for (i = 0; i < GIFT_BIG.length; i++) if (GIFT_BIG[i].split('.')[0] === fixed) { fixed = GIFT_BIG[i]; break; }
    }
    if (GIFT_BIG.indexOf(fixed) < 0) {
      var nm = fixed.split('.')[0], tl = fixed.slice(nm.length + 1);
      var most = nm.length >= 6 ? 2 : (nm.length >= 4 ? 1 : 0);
      var best = null, bestD = 99;
      for (i = 0; i < GIFT_BIG.length; i++) {
        var bn = GIFT_BIG[i].split('.')[0], bt = GIFT_BIG[i].slice(bn.length + 1);
        var dd = giftDist(fixed, GIFT_BIG[i]);
        var near = (bn === nm && fixed.split('.').length === 2) || dd <= most ||
          (nm.length === 3 && bt === tl && bn.split('').sort().join('') === nm.split('').sort().join(''));
        if (near && dd < bestD) { bestD = dd; best = GIFT_BIG[i]; }
      }
      if (best) fixed = best;
    }
    return { valid: valid, fix: (fixed !== dom && localOk && GIFT_DOMAIN.test(fixed)) ? local + '@' + fixed : null };
  }
  function giftEditor() {
    if (window.__vcGiftEditor) return;
    window.__vcGiftEditor = true;
    function each(fn) { Array.prototype.forEach.call(document.querySelectorAll('[data-vc-gift][data-vc-bound]'), fn); }
    document.addEventListener('shopify:block:select', function (e) {
      var id = e.detail && e.detail.blockId;
      window.__vcGiftSel = id;
      each(function (b) { if (id && b.getAttribute('data-vc-gift-block') === id && b.__vcOpen) b.__vcOpen(); });
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var id = e.detail && e.detail.blockId;
      if (window.__vcGiftSel === id) window.__vcGiftSel = null;
      each(function (b) { if (id && b.getAttribute('data-vc-gift-block') === id && b.__vcClose) b.__vcClose(); });
    });
    /* a section that is re-rendered or removed takes its card along */
    document.addEventListener('shopify:section:unload', function (e) {
      var sid = e.detail && e.detail.sectionId;
      each(function (b) {
        if (sid && b.getAttribute('data-vc-gift-section') !== sid) return;
        if (b.parentNode) b.parentNode.removeChild(b);
        document.documentElement.classList.remove('vc-gift-open');
      });
    });
  }
  function bindGift() {
    var box = document.querySelector('.vc [data-vc-gift]:not([data-vc-bound])');
    if (!box) return;
    box.setAttribute('data-vc-bound', '1');
    var root = box.closest('.vc');
    var design = !!(window.Shopify && Shopify.designMode);
    /* one card at a time: an earlier render of it goes */
    Array.prototype.forEach.call(document.querySelectorAll('[data-vc-gift][data-vc-bound]'), function (old) {
      if (old !== box && old.parentNode) old.parentNode.removeChild(old);
    });
    document.documentElement.classList.remove('vc-gift-open');
    if (root) floatWrap(root).appendChild(box);
    if (design) giftEditor();
    var card = box.querySelector('.gift-card');
    var form = box.querySelector('form');
    var input = box.querySelector('input[type="email"]');
    var err = box.querySelector('.gift-err');
    var btn = box.querySelector('.gift-btn');
    var tab = box.querySelector('[data-vc-gift-open]');
    var blockId = box.getAttribute('data-vc-gift-block') || '';
    var code = (box.getAttribute('data-vc-gift-code') || '').trim();
    var variant = box.getAttribute('data-vc-gift-variant');
    var delay = parseInt(box.getAttribute('data-vc-gift-delay'), 10);
    var days = parseInt(box.getAttribute('data-vc-gift-days'), 10);
    if (!(delay >= 0)) delay = 240;
    if (!(days > 0)) days = 30;
    var KEY = 'vcGift:' + (code || 'gift').toLowerCase();
    function sget(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
    function sset(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
    function sdel(store, k) { try { window[store].removeItem(k); } catch (e) {} }
    /* back from Shopify's robot check with this form's data? */
    var again = false;
    try {
      var q = new URLSearchParams(window.location.search);
      var fk = q.get('form_key');
      if (form && fk && q.get('form_type') === 'customer') {
        var saved = JSON.parse(sget('sessionStorage', fk) || 'null');
        again = !!(saved && String(saved.action || '').indexOf(form.id) >= 0);
      }
    } catch (e) {}
    /* or back from Shopify with the address refused? The page then shows
       the form's errors and carries this form's anchor */
    var failed = !!form && !!box.querySelector('[data-vc-gift-failed]') && window.location.hash === '#' + form.id;
    if (again || failed) sdel('localStorage', KEY + ':done');
    var done = parseInt(sget('localStorage', KEY + ':done'), 10);
    if (!design && done && (Date.now() - done) < days * 864e5) return;
    var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (route.charAt(route.length - 1) !== '/') route += '/';
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var overlays = themeOverlays();
    var timer = 0, opener = null;
    function captcha() {
      var c = window.Shopify && Shopify.captcha;
      return c && typeof c.protect === 'function' ? c : null;
    }
    function bound() { return !!form && form.hasAttribute('data-hcaptcha-bound'); }
    /* wire up Shopify's spam protection, unless it is already on its way */
    function arm() {
      var c = captcha();
      if (design || !c || !form || bound() || form.dataset.cptcha) return;
      try { c.protect(form); } catch (e) {}
    }
    function lock(on) { document.documentElement.classList.toggle('vc-gift-open', on); }
    /* the heading on a phone: when it wraps but would fit on one line at no
       less than 80% of its size, it gets the size that fits */
    var head = box.querySelector('.gift-h');
    var phone = window.matchMedia ? matchMedia('(max-width: 640px)') : null;
    function fitHead() {
      if (!head) return;
      head.style.fontSize = '';
      if (!phone || !phone.matches || !box.classList.contains('is-open')) return;
      var cs = getComputedStyle(head);
      var size = parseFloat(cs.fontSize);
      var line = parseFloat(cs.lineHeight) || size * 1.2;
      if (!(size > 0) || head.offsetHeight < line * 1.5) return;
      head.style.whiteSpace = 'nowrap';
      var need = head.scrollWidth;
      head.style.whiteSpace = '';
      var k = need > 0 ? head.clientWidth / need : 1;
      if (k < 1 && k >= 0.8) head.style.fontSize = (size * k * 0.985).toFixed(2) + 'px';
    }
    function open(from) {
      clearTimeout(timer);
      opener = from || null;
      box.classList.remove('is-min');
      box.classList.add('is-open');
      lock(true);
      fitHead();
      requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('in'); }); });
      if (!design) sset('sessionStorage', KEY, 'seen');
      setTimeout(function () { if (card && card.focus) card.focus({ preventScroll: true }); }, reduce ? 0 : 340);
    }
    function close() {
      box.classList.remove('in');
      lock(false);
      var fin = function () {
        box.classList.remove('is-open');
        box.classList.add('is-min');
        if (tab && opener && tab.focus) tab.focus({ preventScroll: true });
      };
      if (reduce) fin(); else setTimeout(fin, 320);
      if (!design) sset('sessionStorage', KEY, 'min');
    }
    box.__vcOpen = function () { open(); };
    box.__vcClose = function () { if (box.classList.contains('is-open')) close(); };
    box.hidden = false;
    Array.prototype.forEach.call(box.querySelectorAll('[data-vc-gift-close]'), function (el) {
      el.addEventListener('click', function () { close(); });
    });
    if (tab) tab.addEventListener('click', function () { open(tab); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box.isConnected && box.classList.contains('is-open')) close(); });
    /* the heading is fitted again when the phone turns or the fonts arrive */
    function refit() { if (box.isConnected && box.classList.contains('is-open')) fitHead(); }
    window.addEventListener('resize', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
    var state = design ? null : sget('sessionStorage', KEY);
    if (design) {
      if (blockId && window.__vcGiftSel === blockId) open(); else box.classList.add('is-min');
    } else if (again || failed) {
      open();
    } else if (state === 'min' || state === 'seen') {
      box.classList.add('is-min');
    } else {
      /* not opened yet in this visit: the tab shows right away, and the
         card opens by itself after the set time on this page, unless the
         visitor opens it first. A page the browser brings back from its
         cache checks again, as the card may have been opened on another
         page meanwhile or the address sent. */
      box.classList.add('is-min');
      var tries = 0;
      var fire = function () {
        var st = sget('sessionStorage', KEY), signed = parseInt(sget('localStorage', KEY + ':done'), 10);
        if (st === 'min' || st === 'seen' || (signed && (Date.now() - signed) < days * 864e5)) return;
        if (overlayOpen(overlays) && tries++ < 12) { timer = setTimeout(fire, 5000); return; }
        open();
      };
      timer = setTimeout(fire, delay * 1000);
    }
    /* the pictures: a snap row that follows a finger swipe, the numbered
       buttons under it, the arrows and the arrow keys */
    var slides = box.querySelector('[data-gift-slides]');
    if (slides && slides.children.length > 1) {
      var dots = Array.prototype.slice.call(box.querySelectorAll('.gift-dots button'));
      var n = slides.children.length;
      var cur = function () { return Math.min(n - 1, Math.max(0, Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)))); };
      var go = function (i) { i = (i + n) % n; slides.scrollTo({ left: i * slides.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      slides.addEventListener('scroll', function () {
        var i = cur();
        dots.forEach(function (d, j) {
          d.classList.toggle('on', j === i);
          if (j === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
      }, { passive: true });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      var prev = box.querySelector('[data-gift-prev]'), next = box.querySelector('[data-gift-next]');
      if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
      if (next) next.addEventListener('click', function () { go(cur() + 1); });
      if (card) card.addEventListener('keydown', function (e) {
        if (e.target && e.target.tagName === 'INPUT') return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur() - 1); }
      });
    }
    if (!form || !input) return;
    var back = form.querySelector('input[name="return_to"]');
    var hint = box.querySelector('[data-gift-hint]');
    var busy = false, pass = false, calm = 0, asked = '';
    function fail() {
      if (err) {
        if (err.getAttribute('data-msg')) err.textContent = err.getAttribute('data-msg');
        err.hidden = false;
      }
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    }
    function calmNotes() {
      if (err) err.hidden = true;
      input.removeAttribute('aria-invalid');
      if (hint) hint.hidden = true;
      asked = '';
    }
    /* "Did you mean max@gmail.com?", the address a button that takes it */
    function suggest(addr) {
      if (!hint) return;
      hint.textContent = '';
      hint.appendChild(document.createTextNode(hint.getAttribute('data-hint-a') || ''));
      var take = document.createElement('button');
      take.type = 'button';
      take.className = 'gift-fix';
      take.textContent = addr;
      take.addEventListener('click', function () {
        input.value = addr;
        calmNotes();
        input.focus();
      });
      hint.appendChild(take);
      hint.appendChild(document.createTextNode(hint.getAttribute('data-hint-b') || ''));
      if (err) err.hidden = true;
      hint.hidden = false;
    }
    function stop(e) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    }
    function rest() { busy = false; if (btn) btn.removeAttribute('aria-busy'); }
    /* Shopify's cart link: the product with the quantity of the buy area,
       the code and the address, straight into the checkout */
    function target(email) {
      var qtyEl = document.querySelector('#vc-pdp-buy [name="quantity"]');
      var qty = parseInt(qtyEl && qtyEl.value, 10);
      if (!(qty > 0)) qty = 1;
      var q = [];
      if (code) q.push('discount=' + encodeURIComponent(code));
      if (email) q.push('checkout%5Bemail%5D=' + encodeURIComponent(email));
      return route + 'cart/' + variant + ':' + qty + (q.length ? '?' + q.join('&') : '');
    }
    input.addEventListener('input', calmNotes);
    form.addEventListener('submit', function (e) {
      if (pass) return;
      if (busy) { stop(e); return; }
      var email = (input.value || '').trim();
      var c = giftCheck(email);
      /* a suggestion first; a well-formed address typed again as it was
         goes out on the second press */
      if (c.fix && !(c.valid && asked === email)) { stop(e); suggest(c.fix); asked = email; return; }
      if (!c.valid || !input.checkValidity()) { stop(e); fail(); return; }
      if (input.value !== email) input.value = email;
      if (hint) hint.hidden = true;
      busy = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      if (back && variant) back.value = target(email);
      if (!design) sset('localStorage', KEY + ':done', String(Date.now()));
      clearTimeout(calm);
      calm = setTimeout(rest, 12000);
      /* with the spam protection in place (or none in the shop) Shopify
         takes it from here */
      if (bound() || !captcha()) return;
      /* still loading: hold the form until it is ready, then send it the
         same way again */
      stop(e);
      arm();
      var waited = 0, sent = false;
      var send = function () {
        if (sent) return;
        sent = true;
        pass = true;
        try { if (form.requestSubmit) form.requestSubmit(btn || undefined); else form.submit(); } finally { pass = false; }
      };
      (function wait() { if (bound() || waited++ >= 30) send(); else setTimeout(wait, 150); })();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { clearTimeout(calm); rest(); } });
  }

  function bind() { bindVideos(); bindSticky(); bindToTop(); bindBuy(); bindGift(); bindStages(); bindStageExplorer(); bindNotify(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  /* the theme editor re-renders single sections, so re-bind on those events */
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:select', bind);
})();